module.exports = __webpack_public_path__ + "img/2.188848e8.png";